import '@/store/api/sipcentric/typedefs'
import api from '@/store/api/sipcentric'
import * as mutationTypes from './mutation-types'

const initialState = () => ({
    customer: {}
})

const state = initialState()

export default {
    namespaced: true,
    state,
    getters: {
        customer: state => state.customer
    },
    actions: {
        /**
         * @param {SipcentricCustomer} data
         * @returns {Promise<*>}
         */
        createCustomer: async ({dispatch}, data) => {
            try {
                const response = await api.createCustomer(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {SipcentricCustomer} data
         * @returns {Promise<*>}
         */
        updateCustomer: async ({dispatch}, data) => {
            try {
                const response = await api.updateCustomer(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{id: number}} data
         * @returns {Promise<*>}
         */
        showCustomer: async ({commit, dispatch}, data) => {
            try {
                const response = await api.showCustomer(data)
                commit(mutationTypes.SET_CUSTOMER, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{customer_id: number, file: blob}} data
         * @returns {Promise<*>}
         */
        provisionCustomer: async ({dispatch}, data) => {
            try {
                const response = await api.provisionCustomer(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{id: number}} data
         * @returns {Promise<*>}
         */
        disableCustomer: async ({dispatch}, data) => {
            try {
                const response = await api.disableCustomer(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetCustomer: async ({commit}) => commit(mutationTypes.RESET_CUSTOMER)
    },
    mutations: {
        [mutationTypes.SET_CUSTOMER]: (state, data) => state.customer = data,
        [mutationTypes.RESET_CUSTOMER]: (state) => Object.assign(state, initialState())
    }
}
